import { render, staticRenderFns } from "./VulnerabilityTechnicalDetails.vue?vue&type=template&id=505f4e17"
import script from "./VulnerabilityTechnicalDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./VulnerabilityTechnicalDetails.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports